import React from 'react';

import { netcreditBaseUrl } from '@consumer-frontend/nc-api';
import {
  HEADER_LOGO_URI,
  mergeClassNameStrings,
} from '@consumer-frontend/nc-utils';
import {
  Container,
  Image,
} from '@consumer-frontend/shared-ui';

import { NcSupportNumberLink } from '../NcSupportNumberLink';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/apply/apply-header.scss';

export type NcApplyHeaderPropsT = {
  className?: string;
};
export type NcApplyHeaderT = React.FC<NcApplyHeaderPropsT>;

export const NcApplyHeader: NcApplyHeaderT = ({ className }) => {
  const rootClassName = mergeClassNameStrings('apply-header', className);

  return (
    <header className={rootClassName}>
      <Container className="d-none d-md-flex shadow-sm apply-header__desktop">
        <div className="apply-header__desktop-content">
          <a aria-label="NetCredit Home" href={netcreditBaseUrl}>
            <Image
              alt="NetCredit Logo"
              className="apply-header__logo"
              src={HEADER_LOGO_URI}
            />
          </a>

          <NcSupportNumberLink className="apply-header__support-number" withIcon />
        </div>
      </Container>

      <Container className="d-flex d-md-none shadow-sm apply-header__mobile">
        <a aria-label="NetCredit Home" href={netcreditBaseUrl}>
          <Image
            alt="NetCredit Logo"
            className="apply-header__logo"
            src={HEADER_LOGO_URI}
          />
        </a>
      </Container>
    </header>
  );
};
